import{useChatState as t}from"./use-chat-state.hook.js";const o=()=>t().features;export{o as useChatFeatures};